/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-editor-tab/doc-viewer-editor-tab.component.scss */
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.redaction-animation {
  animation: fadeInOut 2s infinite;
  font-size: 48px;
  margin-top: 12px;
  color: #243e90;
}
.content-body {
  background-color: #f5f5f5;
}
.icon-container {
  cursor: pointer;
  margin: 8px;
  font-size: 20px;
  border-radius: 50%;
}
.icon {
  color: #243e90;
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 50%;
}
.icon:hover {
  transform: scale(1.1);
  box-shadow: 0 0 2px 2px #3a4db6;
  border-radius: 50%;
}
:host-context(.dark-theme) .content-body {
  background-color: inherit;
}
:host-context(.dark-theme) .redaction-animation {
  color: #FFC107;
}
:host-context(.dark-theme) .icon {
  color: #FFC107;
}
:host-context(.dark-theme) .icon:hover {
  box-shadow: 0 0 2px 2px rgba(255, 255, 255, 0.8);
  z-index: 25;
  border-radius: 50%;
}
/*# sourceMappingURL=doc-viewer-editor-tab.component.css.map */
